export const MasterFireBase = {
  apiKey: "AIzaSyBPPyaIV9DwrnEZ5SclfQojjY7DJIgbQU4",
   authDomain: "keiken-3873c.firebaseapp.com",
   databaseURL: "https://keiken-3873c.firebaseio.com",
   projectId: "keiken-3873c",
   storageBucket: "keiken-3873c.appspot.com",
   messagingSenderId: "565331112034"
}

export const yelpKey = {
  apikey: "nWiLPtaF4tub0D7MznPldy_kA5H3loqkcYi5Hw1AyxndUDka-IwC5NvGBQ5snaxMFGtq3WPgS_a6yf-5aV2BtkQCNxytrO-CdAVN_XqVVT0P593Z6C4n5bN8bMLHWnYx"
}



// WEBPACK FOOTER //
// /Users/kaitlynfujihara/Desktop/keiken/src/local/api-keys.ts